"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fetchAllMerchants = void 0;
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var fetchAllMerchants = function fetchAllMerchants(accessToken) {
  return _axios["default"].get('https://merchant-config.commerce.cimpress.io/v0/merchants', {
    headers: {
      'Authorization': "Bearer ".concat(accessToken)
    }
  }).then(function (response) {
    return response.data.filter(function (m) {
      return !m.merchantId.startsWith('vcs-');
    }).map(function (merchant) {
      return {
        entityId: merchant.merchantId,
        entityType: 'Merchant',
        entityName: merchant.displayName
      };
    });
  });
};
exports.fetchAllMerchants = fetchAllMerchants;